import type { OrderStatus } from "@/lib/api/types";
import type { SellerOrderStatusStyle } from "./order-list.types";

export const ORDERS_CURRENCY_CODE = "EGP";

export const statusStyleMap: Record<OrderStatus, SellerOrderStatusStyle> = {
  draft: {
    badgeClass:
      "border-[color:var(--border-light)] bg-[color:var(--surface-alt)] text-[color:var(--text-primary)]",
    dotClass: "bg-[color:var(--text-muted)]",
  },
  pending_buyer_verification: {
    badgeClass:
      "border-[color:var(--warning-500)]/35 bg-[color:var(--warning-500)]/8 text-[color:var(--text-primary)]",
    dotClass: "bg-[color:var(--warning-500)]",
  },
  pending_buyer_payment: {
    badgeClass:
      "border-[color:var(--warning-500)]/35 bg-[color:var(--warning-500)]/8 text-[color:var(--text-primary)]",
    dotClass: "bg-[color:var(--warning-500)]",
  },
  pending_payment_verification: {
    badgeClass:
      "border-[color:var(--warning-500)]/35 bg-[color:var(--warning-500)]/8 text-[color:var(--text-primary)]",
    dotClass: "bg-[color:var(--warning-500)]",
  },
  pending_seller_confirmation: {
    badgeClass:
      "border-[color:var(--warning-500)]/35 bg-[color:var(--warning-500)]/8 text-[color:var(--text-primary)]",
    dotClass: "bg-[color:var(--warning-500)]",
  },
  paid_less_than_required: {
    badgeClass:
      "border-[color:var(--warning-500)]/35 bg-[color:var(--warning-500)]/8 text-[color:var(--text-primary)]",
    dotClass: "bg-[color:var(--warning-500)]",
  },
  confirmed: {
    badgeClass:
      "border-[color:var(--success-500)]/30 bg-[color:var(--success-500)]/8 text-[color:var(--text-primary)]",
    dotClass: "bg-[color:var(--success-500)]",
  },
  preparing: {
    badgeClass:
      "border-[color:var(--primary-500)]/25 bg-[color:var(--primary-500)]/10 text-[color:var(--primary-700)]",
    dotClass: "bg-[color:var(--primary-500)]",
  },
  shipped: {
    badgeClass:
      "border-[color:var(--primary-500)]/25 bg-[color:var(--primary-500)]/10 text-[color:var(--primary-700)]",
    dotClass: "bg-[color:var(--primary-500)]",
  },
  delivered: {
    badgeClass:
      "border-[color:var(--success-500)]/30 bg-[color:var(--success-500)]/8 text-[color:var(--text-primary)]",
    dotClass: "bg-[color:var(--success-500)]",
  },
  declined: {
    badgeClass:
      "border-[color:var(--error-500)]/30 bg-[color:var(--error-500)]/10 text-[color:var(--error-500)]",
    dotClass: "bg-[color:var(--error-500)]",
  },
  cancelled: {
    badgeClass:
      "border-[color:var(--error-500)]/30 bg-[color:var(--error-500)]/10 text-[color:var(--error-500)]",
    dotClass: "bg-[color:var(--error-500)]",
  },
};
